import { render, staticRenderFns } from "./AudioAddFile.vue?vue&type=template&id=ccc663b6&"
import script from "./AudioAddFile.vue?vue&type=script&lang=js&"
export * from "./AudioAddFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports